import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/data';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20modern%20navigation%20hub%20visualization%20with%20warm%20golden%20and%20amber%20tones%20flowing%20organic%20geometric%20patterns%20representing%20interconnected%20knowledge%20zones%20soft%20gradient%20atmosphere%20minimalist%20clean%20design%20high%20detail%20harmonious%20composition%20editorial%20photography%20style%20with%20smooth%20lighting&width=1600&height=900&seq=hero-main-bg&orientation=landscape"
        alt="一区二区内容资源导航"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="relative z-10 w-full max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
          {siteInfo.tagline}
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-[600px] mx-auto leading-relaxed">
          {siteInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/yiqu-overview"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            探索一区
          </Link>
          <Link
            to="/category/erqu-overview"
            className="px-8 py-3 bg-background-50/20 text-white border border-white/30 rounded-lg text-sm font-semibold hover:bg-background-50/30 transition-colors whitespace-nowrap"
          >
            探索二区
          </Link>
        </div>
      </div>
    </section>
  );
}